import { FormHelperText, Grid, Typography } from '@material-ui/core'
import useStyles from './styles'
import { FC } from 'react'
import { useStepperContext } from 'hooks/useStepperContext'
import { useSelector } from 'react-redux'
import { getApprovalValues } from 'ducks/selectors'
import Contact from '../Contact'


export interface HomeownerInformationProps { }

const HomeownerInformation: FC<HomeownerInformationProps> = () => {
  const classes = useStyles()

  const { saveNewValue, showWarnings } = useStepperContext()
  const { homeowner, homeownersEmailAlreadyExists } =
    useSelector(getApprovalValues())

  return (
    <>
      <Grid item className={classes.homeownerInformation}>
        <Typography className={classes.titleWithoutMarging}>
          📞 homeowner contact information
        </Typography>
        <Typography className={classes.subtitle}>
          The Homeowner’s contact information is required to complete the services agreement.
        </Typography>
        <Grid item>
          <Contact
            contact={homeowner}
            style={{
              marginBottom: '2rem',
            }}
            onChange={(key, val) => {
              saveNewValue('homeowner', {
                ...homeowner,
                [key]: val,
              })
            }}
          />
          {showWarnings && homeownersEmailAlreadyExists && (
            <FormHelperText error style={{ marginTop: 8 }}>
              This email is already associated with another contact on this
              estimate.
            </FormHelperText>
          )}
        </Grid>
      </Grid>
    </>
  )
}

export default HomeownerInformation
